export const US_SPORTS = ["NFL", "NHL", "NBA", "WNBA", "MLB"];

export const SOCCER_LEAGUES = [
  { code: "EPL", label: "Premier League" },
  { code: "LALIGA", label: "La Liga" },
  { code: "BUNDESLIGA", label: "Bundesliga" },
  { code: "SERIEA", label: "Serie A" },
  { code: "LIGAMX", label: "Liga MX" },
  { code: "MLS", label: "MLS" },
  { code: "BRASIL", label: "Brasileirão" },
  { code: "UCL", label: "Champions League" },
  { code: "UEL", label: "Europa League" },
];

export const SOCCER_CODES = SOCCER_LEAGUES.map((l) => l.code);
export const ALL_SPORT_CODES = [...US_SPORTS, ...SOCCER_CODES];

export const isSoccer = (code) => SOCCER_CODES.includes(code);
export const labelFor = (code) => SOCCER_LEAGUES.find((l) => l.code === code)?.label || code;
